import React from "react";

const GeneralInstructions = ({ quesLength, onProceed, proceedLabel = "Start Test" }) => {
  return (
    <div className="gi-root">
      <div className="gi-card">
        <div className="gi-card-inner">
          <header className="gi-header">
            <h2 className="gi-title">General Instructions</h2>
            <p className="gi-lead">
              Please read the following instructions carefully. They will help you complete the
              test without interruptions and ensure accurate scoring.
            </p>
          </header>

          <div className="gi-body">
            <ol className="gi-list">
              <li>
                This is a multiple-choice (MCQ) test containing <strong>{quesLength}</strong> questions.
                Each question has a single correct answer.
              </li>

              <li>
                The test is timed. The server clock controls the countdown timer — when the time
                elapses the test will be submitted automatically. You may submit early using the
                Submit button.
              </li>

              <li>
                Use the Question Palette on the left to navigate. The palette shows each question's
                current status (answered, not answered, not visited, etc.).
              </li>

              <li>
                Click any question number in the palette to jump directly to that question, or use
                Next / Previous to move sequentially.
              </li>

              <li>
                Select an option by clicking the radio bubble beside it. Responses are saved when you
                navigate away from a question.
              </li>

              <li>
                To change your answer, simply choose a different option. To clear your response,
                use the Clear Response control.
              </li>
            </ol>

            <div className="gi-status-row" aria-hidden="false">
              <StatusBadge label="Answered" variant="answered" />
              <StatusBadge label="Not Visited" variant="not-visited" />
              <StatusBadge label="Visited — Not Answered" variant="visited-not-answered" />
              <StatusBadge label="Current" variant="current" />
            </div>
          </div>

          <footer className="gi-footer">
            <button
              className="gi-button"
              onClick={() => typeof onProceed === "function" && onProceed()}
            >
              <span>{proceedLabel}</span>
              <span className="gi-button-icon">→</span>
            </button>
          </footer>
        </div>
      </div>
    </div>
  );
};

const StatusBadge = ({ label, variant }) => {
  return (
    <div className="gi-badge">
      <span className={`gi-badge-dot ${variant}`} />
      <span className="gi-badge-label">{label}</span>
    </div>
  );
};

export default GeneralInstructions;
